import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import components from './components';

const makeRootReducer = (asyncReducers = {}) =>
  combineReducers({
    router: routerReducer,
    components: components(),
    ...asyncReducers,
  });

/* eslint-disable */
export const injectReducer = (store, { key, reducer }) => {
  if (Object.hasOwnProperty.call(store.asyncReducers, key)) return;

  store.asyncReducers[key] = reducer;
  store.replaceReducer(makeRootReducer(store.asyncReducers));
};
/* eslint-enable */

export default makeRootReducer;



// WEBPACK FOOTER //
// ./app/javascript/pro_platform/store/reducers.js